<template>
  <header class="s-header-base">
    <SEnvironmentDisplay class="s-header-base__env" />
    <SAppContainer class="s-header-base__content">
      <span v-if="disableLogoLink" class="s-header-base__title">
        <img
          :alt="tr('main_site.layout.header_logo_alt')"
          class="s-header-base__logo"
          height="28"
          :src="logoUrl"
          width="116"
        />
      </span>
      <a
        v-else
        class="s-header-base__title"
        :href="ziggyUnsafe('mainSite.homepage')"
      >
        <img
          :alt="tr('main_site.layout.header_logo_alt')"
          class="s-header-base__logo"
          height="28"
          :src="logoUrl"
          width="116"
        />
      </a>

      <slot name="left" />

      <div class="s-header-base__spacer" />

      <slot name="right" />
    </SAppContainer>
  </header>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { ziggyUnsafe } from "@solvari/common-fe/integrations";
import { useI18nMainSiteLayout } from "@solvari/translations";
import { getEnv } from "@solvari/utils";

import SAppContainer from "../../atoms/SAppContainer.vue";
import SEnvironmentDisplay from "../../atoms/SEnvironmentDisplay.vue";

defineProps<{
  disableLogoLink?: boolean;
}>();

const { tr } = useI18nMainSiteLayout();

const logoUrl = computed(
  () => `${getEnv().network.static}/shared/svg/solvari.svg`,
);
</script>

<style lang="postcss">
.s-header-base {
  @apply sticky left-0 right-0 top-0 z-50 h-14 w-full max-w-full bg-white shadow;

  &__content {
    @apply flex items-center gap-2;
  }

  &__title {
    @apply mr-4 flex h-14 min-w-0 items-center;
  }

  &__logo {
    @apply h-7 w-auto;
  }

  &__spacer {
    @apply flex-1;
  }

  &__env {
    @apply absolute left-0 z-[99105];
  }

  @screen 500 {
    @apply h-16;

    &__title {
      @apply h-16;
    }
  }

  @screen 1000 {
    @apply static;
  }
}
</style>
